import { render, staticRenderFns } from "./safeWorkPermitDetail.vue?vue&type=template&id=13c175ec"
import script from "./safeWorkPermitDetail.vue?vue&type=script&lang=js"
export * from "./safeWorkPermitDetail.vue?vue&type=script&lang=js"
import style0 from "./safeWorkPermitDetail.vue?vue&type=style&index=0&id=13c175ec&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c175ec')) {
      api.createRecord('13c175ec', component.options)
    } else {
      api.reload('13c175ec', component.options)
    }
    module.hot.accept("./safeWorkPermitDetail.vue?vue&type=template&id=13c175ec", function () {
      api.rerender('13c175ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/safeWorkPermitDetail.vue"
export default component.exports